// extracted by mini-css-extract-plugin
module.exports = {"root":"PatientBlock_root__1FARj","header":"PatientBlock_header__nlIN2","label":"PatientBlock_label__2Ty42","option":"PatientBlock_option__euKfh"};